import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export function BudgetValidationSchema() {
  const { t } = useTranslation();

  const validation = Yup.object().shape({
    patient_id: Yup.string().required(t("MESSAGE.patient_id_required")),
    observations: Yup.string().optional(),
    voucherCode: Yup.string().optional(),
    status: Yup.string().required(t("MESSAGE.status_required")),
    procedures: Yup.array()
      .min(1, "Pelo menos um procedimento é obrigatório")
      .of(
        Yup.object().shape({
          id: Yup.string().required("Procedimento é obrigatório"),
          employee_id: Yup.string().required("Profissional é obrigatório"),
          value: Yup.number()
            .moreThan(0, "Valor deve ser maior que zero")
            .required(),
          quantity: Yup.number().min(1, "Mínimo 1 sessão").required(),
        })
      ),
  });

  return validation;
}

export function BudgetRequestProcedureValidationSchema() {
  const { t } = useTranslation();

  const validation = Yup.object().shape({
    id: Yup.string().required(t("MESSAGE.procedure_id_required")),
    quantity: Yup.number()
      .min(1, t("MESSAGE.procedure_quantity_min"))
      .required(t("MESSAGE.procedure_quantity_required")),
    value: Yup.number()
      .min(0, t("MESSAGE.procedure_value_min"))
      .required(t("MESSAGE.procedure_value_required")),
    employee_id: Yup.string().required(t("MESSAGE.employee_id_required")),
  });

  return validation;
}
